export const wait = (millis: number) => new Promise(resolve => setTimeout(resolve, millis))

export const timeout = <T = any>(promise: Promise<T>, time: number): Promise<T> =>
    Promise.race([promise, new Promise<never>((res, rej) => setTimeout(rej, time))])
